var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationLockclosed = function SvgSimpleIllustrationLockclosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ED7DE",
    d: "M38.05 22.19H9.882v9.66s.272 11.736 14.987 11.646c9.66 0 13.363-8.666 13.453-12.277.09-3.61-.273-9.028-.273-9.028Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA6A6",
    d: "M12.682 22.101h-2.8v10.022s1.083 10.925 12.639 11.194c0 0-9.39-2.348-10.022-12.729-.362-5.777.18-8.487.18-8.487h.003Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D18000",
    d: "M24.78 24.45s2.437 1.534 2.437 3.158c0 1.625-1.083 3.611-1.714 3.793l1.355 8.308 2.076-.362-1.265-8.487s2.166-1.445 1.807-3.16c-.36-1.713-1.625-3.882-4.694-3.248l-.003-.003Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M25.5 31.401s1.777-1.594 1.777-3.341-1.684-3.371-3.01-3.371c-1.325 0-2.187 2.23-2.165 2.707.018.479.783 2.83 1.744 3.491l-1.625 8.607s3.73.783 4.634.21L25.5 31.395v.005Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D18000",
    d: "m17.827 22.011-.201-1.714s.302-.451-1.105-.451-3.817.09-3.817.09-.803.089-.803.72v1.355h5.926ZM36.545 22.011l-.201-1.714s.302-.451-1.105-.451-3.818.09-3.818.09-.802.089-.802.72v1.355h5.929-.003Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4BC07",
    d: "m35.944 19.513-.224-5.093s-2.125-9.771-11.545-9.472c-9.417.302-11.512 9.333-11.512 9.333l-.553 5.355 5.091-.12.025-4.394s1.573-5.287 6.985-5.352c5.412-.066 6.497 5.412 6.497 5.412l.602 4.574 4.634-.24v-.003Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.273 22.123v8.416c0 7.145-5.793 12.938-12.939 12.938-7.145 0-12.938-5.793-12.938-12.938v-8.416h25.877v0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.968 43.477c-11.564 0-16.062-5.793-16.062-12.94V22.12h3.279"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.424 27.875a3.652 3.652 0 0 0-7.303 0c0 1.33.713 2.49 1.774 3.13l-1.817 8.342s3.096 1.826 6.827 0l-1.51-8.207a3.65 3.65 0 0 0 2.027-3.268l.002.003Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26.763 39.665-1.51-8.206a3.65 3.65 0 0 0-.89-6.846M11.781 21.946V20.61c0-.446.417-.805.93-.805h4.186c.514 0 .93.361.93.805v1.336M30.498 21.946V20.61c0-.446.417-.805.931-.805h4.185c.514 0 .93.361.93.805v1.336M17.199 19.805v-3.306a6.974 6.974 0 1 1 13.947 0v3.276"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.943 19.772v-3.056c0-6.5-5.268-11.768-11.768-11.768-6.498 0-11.766 5.268-11.766 11.768v3.089"
  })));
};
export default SvgSimpleIllustrationLockclosed;